// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bo5xp","colBig":"styles_colBig__3k5C4","colSmall":"styles_colSmall__3g1-_"};